<template>
  <div class="exchangeBaseInfo">
    <div v-loading="loading" class="rj-page-card">
      <div class="rj-page-card__title">
        换货合同
      </div>
      <div class="rj-page-card__content">
        <el-form ref="form" :model="info" :rules="rules" class="baseInfoForm">
          <div class="rj-col-3">
            <div class="rj-baseinfo">
              <div class="rj-baseinfo__label">
                项目名称：
              </div>
              <div class="rj-baseinfo__item">
                {{ infoAll.rprojectName }}
              </div>
            </div>
          </div>
          <div class="rj-row">
            <div class="rj-col-3">
              <div class="rj-baseinfo">
                <div class="rj-baseinfo__label">
                  原合同编号：
                </div>
                <div class="rj-baseinfo__item">
                  {{ infoAll.roldContractNum }}
                </div>
              </div>
            </div>
            <div class="rj-col-3">
              <div class="rj-baseinfo">
                <div class="rj-baseinfo__label">
                  订单日期：
                </div>
                <div class="rj-baseinfo__item">
                  {{ infoAll.rcreatedTime }}
                </div>
              </div>
            </div>
            <div class="rj-col-3">
              <div class="rj-baseinfo">
                <div class="rj-baseinfo__label">
                  电子商务合同编号：
                </div>
                <div class="rj-baseinfo__item">
                  {{ infoAll.rnewContractNum }}
                </div>
              </div>
            </div>
            <div class="rj-col-3">
              <div class="rj-baseinfo">
                <div class="rj-baseinfo__label">
                  客户合同编号：
                </div>
                <div class="rj-baseinfo__item">
                  <el-input v-model="infoAll.rnewContractCustomerNum" disabled placeholder="请输入客户合同编号" />
                </div>
              </div>
            </div>
            <div class="rj-col-3">
              <div class="rj-baseinfo">
                <div class="rj-baseinfo__label">
                  订单分类：
                </div>
                <div class="rj-baseinfo__item">
                  {{ infoAll.rorderType }}
                </div>
              </div>
            </div>
            <div class="rj-col-3">
              <div class="rj-baseinfo">
                <div class="rj-baseinfo__label">
                  供货单位(甲方)：
                </div>
                <div class="rj-baseinfo__item">
                  {{ infoAll.supplyUnit }}
                </div>
              </div>
            </div>
            <div class="rj-col-3">
              <div class="rj-baseinfo">
                <div class="rj-baseinfo__label">
                  供货单位地址：
                </div>
                <div class="rj-baseinfo__item">
                  {{ infoAll.supplyAddress }}
                </div>
              </div>
            </div>
            <div class="rj-col-3">
              <div class="rj-baseinfo">
                <div class="rj-baseinfo__label">
                  供货单位电话(甲方)：
                </div>
                <div class="rj-baseinfo__item">
                  {{ infoAll.supplyPhone }}
                </div>
              </div>
            </div>
            <div class="rj-col-3">
              <div class="rj-baseinfo">
                <div class="rj-baseinfo__label">
                  订货单位(乙方)：
                </div>
                <div class="rj-baseinfo__item">
                  {{ infoAll.rorderUnitName }}
                </div>
              </div>
            </div>
            <div class="rj-col-3">
              <div class="rj-baseinfo">
                <div class="rj-baseinfo__label">
                  订货单位电话(乙方)：
                </div>
                <div class="rj-baseinfo__item">
                  <el-input v-model="infoAll.rorderUnitTel" placeholder="请输入订货单位电话" />
                </div>
              </div>
            </div>
            <div class="rj-col-3">
              <div class="rj-baseinfo">
                <div class="rj-baseinfo__label">
                  最终客户：
                </div>
                <div class="rj-baseinfo__item">
                  {{ infoAll.rfinalCustomerName }}
                </div>
              </div>
            </div>
            <div class="rj-col-3">
              <div class="rj-baseinfo">
                <div class="rj-baseinfo__label">
                  客户签约类型：
                </div>
                <div class="rj-baseinfo__item">
                  {{ infoAll.rdistributorName }}
                </div>
              </div>
            </div>
            <div class="rj-col-3">
              <div class="rj-baseinfo">
                <div class="rj-baseinfo__label">
                  区域：
                </div>
                <div class="rj-baseinfo__item">
                  {{ infoAll.rsalesArea }}
                </div>
              </div>
            </div>
            <div class="rj-col-3">
              <div class="rj-baseinfo">
                <div class="rj-baseinfo__label">
                  首级集成商名称：
                </div>
                <div class="rj-baseinfo__item">
                  {{ infoAll.rintegratorName }}
                </div>
              </div>
            </div>
            <div class="rj-col-3">
              <div class="rj-baseinfo">
                <div class="rj-baseinfo__label">
                  首级集成商类型：
                </div>
                <div class="rj-baseinfo__item">
                  {{ infoAll.rintegratorSignType }}
                </div>
              </div>
            </div>
            <div class="rj-col-3">
              <div class="rj-baseinfo">
                <div class="rj-baseinfo__label">
                  区域商务专员：
                </div>
                <div class="rj-baseinfo__item">
                  {{ infoAll.rassistantName }}
                </div>
              </div>
            </div>
            <div class="rj-col-3">
              <div class="rj-baseinfo">
                <div class="rj-baseinfo__label">
                  售前名称：
                </div>
                <div class="rj-baseinfo__item">
                  {{ infoAll.rpreSalesPersonName }}
                </div>
              </div>
            </div>
            <div class="rj-col-3">
              <div class="rj-baseinfo">
                <div class="rj-baseinfo__label">
                  销售名称：
                </div>
                <div class="rj-baseinfo__item">
                  {{ infoAll.rsalesPersonName }}
                </div>
              </div>
            </div>
            <div class="rj-col-3">
              <div class="rj-baseinfo">
                <div class="rj-baseinfo__label">
                  部门：
                </div>
                <div class="rj-baseinfo__item">
                  {{ infoAll.rsalesPersonDeptName }}
                </div>
              </div>
            </div>
            <div class="rj-col-3">
              <div class="rj-baseinfo">
                <div class="rj-baseinfo__label">
                  计量计点：
                </div>
                <div class="rj-baseinfo__item">
                  {{ infoAll.rmeteringPoint }}
                </div>
              </div>
            </div>
            <div class="rj-col-3">
              <div class="rj-baseinfo">
                <div class="rj-baseinfo__label">
                  服务主体编码：
                </div>
                <div class="rj-baseinfo__item">
                  {{ infoAll.rserviceSubjectCode }}
                </div>
              </div>
            </div>
            <div class="rj-col-3">
              <div class="rj-baseinfo">
                <div class="rj-baseinfo__label">
                  服务主体名称：
                </div>
                <div class="rj-baseinfo__item">
                  {{ infoAll.rserviceSubjectName }}
                </div>
              </div>
            </div>
            <div class="rj-col-3">
              <div class="rj-baseinfo">
                <div class="rj-baseinfo__label">
                  A类产品服务商：
                </div>
                <div class="rj-baseinfo__item">
                  {{ infoAll.rserviceAName }}
                </div>
              </div>
            </div>
            <div class="rj-col-3">
              <div class="rj-baseinfo">
                <div class="rj-baseinfo__label">
                  B类产品服务商：
                </div>
                <div class="rj-baseinfo__item">
                  {{ infoAll.rserviceBName }}
                </div>
              </div>
            </div>
            <div class="rj-col-3">
              <div class="rj-baseinfo">
                <div class="rj-baseinfo__label">
                  C类产品服务商：
                </div>
                <div class="rj-baseinfo__item">
                  {{ infoAll.rserviceCName }}
                </div>
              </div>
            </div>
            <div class="rj-col-3">
              <div class="rj-baseinfo">
                <div class="rj-baseinfo__label">
                  是否使用返利：
                </div>
                <div class="rj-baseinfo__item">
                  <div class="rj-baseinfo__item">
                    {{ infoAll.risUseRebate === 1 ? '是' : '否' }}
                  </div>
                  <template v-if="infoAll.risUseRebate === 1">
                    使用金额: {{ infoAll.ruseRebateAmount || 0 }} 元
                  </template>
                </div>
              </div>
            </div>
            <div class="rj-col-1">
              <el-form-item prop="additionalTerms" label="补充条款:">
                <el-input v-model.trim="infoAll.rsupplementalTerm" type="textarea" :rows="3" placeholder="请输入补充条款内容" />
              </el-form-item>
            </div>
            <div class="rj-col-1">
              <el-form-item prop="additionalTerms" label="备注说明:">
                <el-input v-model.trim="infoAll.rremarks" type="textarea" :rows="3" placeholder="请输入备注说明" />
              </el-form-item>
            </div>
          </div>
        </el-form>
      </div>
    </div>
  </div>
</template>

<script>
/* eslint-disable */
export default {
  props: {
    info: {
      type: Object,
      default: () => { return {}; }
    }
  },

   data () {
    return {
      infoAll: this.info,
      loading: false,
      form: {},
      rules: {},
    };
  },

  watch:{
    info (val) {
      this.infoAll = val;
    },
  }
};
</script>

<style lang='scss'>
.exchangeBaseInfo{
 .rj-col-66 {
    float: left;
    -webkit-box-sizing: border-box;
    box-sizing: border-box;
    width: 66.6666%;
}
}

</style>
